import { render, staticRenderFns } from "./InvoicePayments.vue?vue&type=template&id=0bde5ae7&scoped=true&"
import script from "./InvoicePayments.vue?vue&type=script&lang=js&"
export * from "./InvoicePayments.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePayments.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InvoicePayments.vue?vue&type=style&index=1&id=0bde5ae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bde5ae7",
  null
  
)

export default component.exports